import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["selectable"]

  select(ev) {
    for (const t of this.selectableTargets) {
      if (t == ev.currentTarget) {
        t.classList.add("active")
        $(t).find("input")[0].checked = true
      } else {
        t.classList.remove("active")
        $(t).find("input")[0].checked = false
      }
    }
  }
}
